export default "__VITE_ASSET__9_xZkpPH__"